import { render, staticRenderFns } from "./BatchImportExcel.vue?vue&type=template&id=1252168c&scoped=true"
import script from "./BatchImportExcel.vue?vue&type=script&lang=js"
export * from "./BatchImportExcel.vue?vue&type=script&lang=js"
import style0 from "./BatchImportExcel.vue?vue&type=style&index=0&id=1252168c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1252168c",
  null
  
)

export default component.exports